import { UrgencyIcon } from 'features/geoEvents/components/UrgencyIcon';
import { GeoEventUrgencyLevel } from 'features/geoEvents/geoEvent.types';
import {
  IncidentOwnershipFilter,
  IncidentUrgencyFilter,
  IncidentMetadataFilter,
} from './useMapSearch.types';

/**
 * Ownership filter options with translation keys
 */
export const OWNERSHIP_OPTIONS: Array<{
  value: IncidentOwnershipFilter | '';
  transLabelKey: string;
}> = [
  { value: '', transLabelKey: 'searchBar.all' },
  { value: 'reporter_managed', transLabelKey: 'searchBar.reporterManaged' },
  { value: 'bot_managed', transLabelKey: 'searchBar.botManaged' },
  { value: 'external_reporter', transLabelKey: 'searchBar.externalReporter' },
];

/**
 * Urgency filter options with translation keys and icons
 */
export const URGENCY_OPTIONS: Array<{
  value: IncidentUrgencyFilter;
  transLabelKey: string;
  icon: JSX.Element;
}> = [
  {
    value: GeoEventUrgencyLevel.Urgent,
    transLabelKey: 'searchBar.urgent',
    icon: <UrgencyIcon urgency={GeoEventUrgencyLevel.Urgent} size={19} />,
  },
  {
    value: GeoEventUrgencyLevel.High,
    transLabelKey: 'searchBar.high',
    icon: <UrgencyIcon urgency={GeoEventUrgencyLevel.High} size={19} />,
  },
  {
    value: GeoEventUrgencyLevel.Medium,
    transLabelKey: 'searchBar.medium',
    icon: <UrgencyIcon urgency={GeoEventUrgencyLevel.Medium} size={19} />,
  },
  {
    value: GeoEventUrgencyLevel.Standard,
    transLabelKey: 'searchBar.standard',
    icon: <UrgencyIcon urgency={GeoEventUrgencyLevel.Standard} size={19} />,
  },
  {
    value: GeoEventUrgencyLevel.Stale,
    transLabelKey: 'searchBar.stale',
    icon: <UrgencyIcon urgency={GeoEventUrgencyLevel.Stale} size={19} />,
  },
];

/**
 * Metadata filter options with translation keys
 */
export const METADATA_OPTIONS: Array<{
  value: IncidentMetadataFilter;
  transLabelKey: string;
}> = [
  { value: 'active_evacuations', transLabelKey: 'searchBar.activeEvacuations' },
  { value: 'has_shelters', transLabelKey: 'searchBar.hasShelters' },
  // @todo remove when removing 'internal_tab_on_incidents' release flag
  { value: 'has_recent_notes', transLabelKey: 'searchBar.hasRecentNotes' },
  { value: 'has_active_notes', transLabelKey: 'searchBar.hasActiveNotes' },
  {
    value: 'hide_prescribed_burns',
    transLabelKey: 'searchBar.hidePrescribedBurns',
  },
  {
    value: 'hide_contained_over_50',
    transLabelKey: 'searchBar.hideContainedOver50',
  },
  { value: 'hide_inactive', transLabelKey: 'searchBar.hideInactiveIncidents' },
  { value: 'hide_silent', transLabelKey: 'searchBar.hideSilent' },
];
